import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { Observable, timer } from 'rxjs';
import { environment } from 'src/environments/environment';

interface TokenResponse { session_token: string; expires_in: number; }

@Injectable({ providedIn: 'root' })
export class SessionTokenService {
  public static STORAGE_KEY = 'fynka_session_token';
  public current_token: string | null = null;
  private expiry = 0;
  private refreshSub: any;
  base_url = environment.appRoot + '/api/';

  constructor(private http: HttpClient) { this.restore(); }

  /** Public accessor used by the interceptor */
  get current(): string | null { return this.current_token && Date.now() < this.expiry ? this.current_token : null; }

  /** Request a fresh token from the back-end */
  generate(): Observable<string> {
    return this.http.post<TokenResponse>(this.base_url + 'session-token', {}).pipe(
      map(r => r.session_token),
      tap(t => this.set(t))
    );
  }
  // public getToken(): string | null { return this.current_token; }

  /** Refresh the current token */
  refresh(): Observable<string> {
    return this.http.post<TokenResponse>(this.base_url + 'session-token/refresh', {}).pipe(
      map(r => r.session_token),
      tap(t => this.set(t))
    );
  }

  /** Persist token & schedule pre-expiry refresh */
  private set(token: string) {
    this.current_token = token;
    this.persist();
    // this.scheduleRefresh();
  }

  private scheduleRefresh() {
    if (this.refreshSub) { this.refreshSub.unsubscribe(); }
    const delay = Math.max(this.expiry - Date.now() - 5 * 60 * 1000, 0); // 5 min before expiry
    this.refreshSub = timer(delay).subscribe(() => this.refresh().subscribe());
  }

  private persist() {
    if (!this.current_token) return;
    // Store the token in a secure, httpOnly cookie via backend Set-Cookie when possible.
    // For client-side we fallback to a regular cookie (expires when browser closes).
    document.cookie = `${SessionTokenService.STORAGE_KEY}=${this.current_token}; path=/; SameSite=Lax`;
  }

  private restore() {
    const match = document.cookie.match(new RegExp('(^|; )' + SessionTokenService.STORAGE_KEY + '=([^;]+)'));
    if (!match) return;
    this.current_token = decodeURIComponent(match[2]);
  }
}